module.exports = require("/Users/samdozor/Documents/jenny/jmarzphoto/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 499
// module chunks = 231608221292675